import { Badge } from "@repo/components";
import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";

/**
 * Google's Business Profile API only grants access to applicants who MANAGE A GBP THAT HAS BEEN
 * VERIFIED AND ACTIVE FOR 60+ DAYS — so a freshly-created account can't be allow-listed yet, and every
 * API call returns quota 0 (RESOURCE_EXHAUSTED). The whole feature (connect + reviews + recommendations
 * + phone sync) is built, deployed, and verified end-to-end up to that gate; it is purely blocked on
 * Google's approval.
 *
 * So we show a "coming soon" state on the Channels→Google tab instead of a Connect button that
 * dead-ends. When the Business Profile API access request is granted, flip the PostHog flag
 * `google_business.enabled` on — the real [GoogleBusinessCard] takes over with nothing else to change.
 * See [BookingChannelsPage] for where the flag is read.
 */
export function GoogleBusinessComingSoon() {
  const { t } = useTranslation();
  return (
    <section className={css({ display: "flex", flexDirection: "column", gap: "2", mt: "6" })}>
      <div className={css({ display: "flex", alignItems: "center", gap: "2", flexWrap: "wrap" })}>
        <h3 className={css({ fontSize: "md", fontWeight: "semibold", color: "fg.default" })}>
          {t("googleBusiness.title")}
        </h3>
        <Badge colorPalette="gray">{t("googleBusiness.comingSoon.badge")}</Badge>
      </div>
      <p className={css({ fontSize: "sm", color: "fg.muted" })}>
        {t("googleBusiness.comingSoon.body")}
      </p>
    </section>
  );
}
